export const manifestLocales = {
  summaryPageSubmissionHistory: {
    previewImageAlt: {
      en: 'Summary Page Submission History',
      he: 'תמונת מצב : שיח'
    }
  }
};
